// extracted by mini-css-extract-plugin
export default {"container":"FiguresInputs_container__p5Qd-","label":"FiguresInputs_label__vl-MR"};